import React, { useId } from "react";
import Icon from "./Icon";
import "./AchievementBadge.css";

const TONES = {
  coins: ["#fcd34d", "#b45309"], "piggy-bank": ["#fda4af", "#be123c"],
  sprout: ["#A78BFA", "#5B21B6"], hammer: ["#a5b4fc", "#4338ca"],
  trophy: ["#fcd34d", "#b45309"], flame: ["#fb923c", "#c2410c"],
  zap: ["#7dd3fc", "#0369a1"], target: ["#fda4af", "#be123c"],
};

export default function AchievementBadge({ icon = "trophy", earned = true, size = 80 }) {
  const id = useId().replace(/:/g, "");
  const [light, dark] = earned ? TONES[icon] || TONES.trophy : ["#e2e8f0", "#64748b"];
  return <span className="achievement-emblem" style={{ width: size, height: size }} aria-hidden="true">
    <svg viewBox="0 0 100 108" width="100%" height="100%" focusable="false">
      <defs><linearGradient id={id} x2=".7" y2="1"><stop stopColor={light} /><stop offset="1" stopColor={dark} /></linearGradient></defs>
      <path d="m27 68-5 33 17-8 11 11 7-35m1-2 18 33 5-18 18-4-23-26" fill={dark} />
      <path d="m50 6 35 16v34c0 25-35 41-35 41S15 81 15 56V22Z" fill={dark} />
      <path d="m50 3 35 16v33c0 25-35 41-35 41S15 77 15 52V19Z" fill={`url(#${id})`} stroke="#fff7ed" strokeWidth="3" />
      <path d="m50 12 27 13v27c0 17-27 32-27 32S23 69 23 52V25Z" fill="none" stroke="white" opacity=".65" strokeWidth="2" />
      <path d="m24 26 52 28V25L50 12Z" fill="white" opacity=".2" />
    </svg>
    <Icon name={earned ? icon : "lock"} width={size * .37} height={size * .37} strokeWidth={2.5} className="achievement-symbol" />
  </span>;
}
